import { isEmpty, forEach, trim, cloneDeep, sortBy, mean, defaultsDeep } from "lodash";
// import moment from "moment";

// const isScore = (process.env.VUE_APP_MODE !== 'score' && process.env.VUE_APP_MODE !== 'szzsi') ? false : true;
export default {
    // moment,
    isEmpty,
    forEach,
    trim,
    cloneDeep,
    defaultsDeep,
    sortBy,
    mean,
    // isScore
};
